var map = {
	"./404": 198,
	"./404.svg": 198,
	"./avatar1": 199,
	"./avatar1.jpg": 199,
	"./background1": 200,
	"./background1.jpg": 200,
	"./beatriz": 201,
	"./beatriz.jpg": 201,
	"./bg-call": 173,
	"./bg-call.jpg": 173,
	"./bgfaq": 174,
	"./bgfaq.png": 174,
	"./bgjulaima1": 176,
	"./bgjulaima1.jpg": 176,
	"./bgsplash": 170,
	"./bgsplash.png": 170,
	"./cooking": 169,
	"./cooking.jpg": 169,
	"./foodplaceholder": 202,
	"./foodplaceholder.jpg": 202,
	"./heroSlider": 166,
	"./heroSlider.jpg": 166,
	"./heroSlider2": 168,
	"./heroSlider2.jpg": 168,
	"./heroslider3": 203,
	"./heroslider3.jpg": 203,
	"./hojita": 172,
	"./hojita.png": 172,
	"./home_cat_placeholder": 204,
	"./home_cat_placeholder.jpg": 204,
	"./julaimabg": 167,
	"./julaimabg.jpg": 167,
	"./julieta": 205,
	"./julieta.jpg": 205,
	"./lazy-placeholder": 186,
	"./lazy-placeholder.jpg": 273,
	"./lazy-placeholder.png": 186,
	"./liz": 206,
	"./liz.jpg": 206,
	"./location_list_placeholder": 207,
	"./location_list_placeholder.png": 207,
	"./login": 178,
	"./login.jpg": 178,
	"./logo-julaima": 187,
	"./logo-julaima.jpg": 274,
	"./logo-julaima.png": 187,
	"./logo-white": 208,
	"./logo-white.png": 208,
	"./paypal_2": 177,
	"./paypal_2.svg": 177,
	"./plus": 175,
	"./plus.png": 175,
	"./team_julaimas": 209,
	"./team_julaimas.jpg": 209,
	"./titlebg": 171,
	"./titlebg.png": 171,
	"./top-view-healthy-balanced-vegetarian-food": 210,
	"./top-view-healthy-balanced-vegetarian-food.jpg": 210,
	"./undraw_cooking_re_g99p": 211,
	"./undraw_cooking_re_g99p.svg": 211,
	"./undraw_devices_re_dxae": 212,
	"./undraw_devices_re_dxae.svg": 212,
	"./undraw_eating_together_re_ux62": 213,
	"./undraw_eating_together_re_ux62.svg": 213,
	"./undraw_schedule_re_2vro": 214,
	"./undraw_schedule_re_2vro.svg": 214,
	"./undraw_shopping_app_flsj": 215,
	"./undraw_shopping_app_flsj.svg": 215,
	"./visa_master": 216,
	"./visa_master.png": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;